import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Typography, Box } from "@mui/material";

const BULLET_COLORS = [
  "hsl(150 38% 17%)",
  "hsl(80 97% 45%)",
  "hsl(36 100% 50%)",
  "hsl(210 90% 55%)",
  "hsl(280 70% 55%)",
  "hsl(0 72% 51%)",
];

let bulletIdx = 0;

const components = {
  h1: ({ children }) => (
    <Typography
      sx={{
        fontSize: 20,
        fontFamily: "Segoe UI Semibold, sans-serif, system-ui",
        color: "hsl(150 38% 17%)",
        mt: 1,
        mb: 0.5,
      }}
    >
      {children}
    </Typography>
  ),
  h2: ({ children }) => (
    <Typography
      sx={{
        fontSize: 17,
        fontFamily: "Segoe UI Semibold, sans-serif, system-ui",
        color: "hsl(150 38% 17%)",
        mt: 1.5,
        mb: 0.5,
      }}
    >
      {children}
    </Typography>
  ),
  h3: ({ children }) => (
    <Typography
      sx={{
        fontSize: 15,
        fontFamily: "Segoe UI Semibold, sans-serif, system-ui",
        color: "hsl(150 38% 17%)",
        mt: 1,
        mb: 0.5,
      }}
    >
      {children}
    </Typography>
  ),
  p: ({ children }) => (
    <Typography sx={{ fontSize: 14, lineHeight: 1.8, color: "hsl(150 10% 30%)", mb: 1 }}>
      {children}
    </Typography>
  ),
  strong: ({ children }) => (
    <strong style={{ color: "hsl(150 38% 17%)", fontWeight: 700 }}>{children}</strong>
  ),
  em: ({ children }) => <em style={{ fontStyle: "italic" }}>{children}</em>,
  del: ({ children }) => (
    <del style={{ color: "hsl(150 10% 50%)", textDecoration: "line-through" }}>{children}</del>
  ),
  ul: ({ children }) => <Box component="ul" sx={{ pl: 0, my: 0.5, listStyle: "none" }}>{children}</Box>,
  ol: ({ children }) => <Box component="ol" sx={{ pl: 2.5, my: 0.5 }}>{children}</Box>,
  li: ({ children, ordered }) => {
    if (ordered) {
      return (
        <Box component="li" sx={{ mb: 0.5 }}>
          <Typography sx={{ fontSize: 14, lineHeight: 1.8, color: "hsl(150 10% 30%)" }}>
            {children}
          </Typography>
        </Box>
      );
    }
    const color = BULLET_COLORS[bulletIdx % BULLET_COLORS.length];
    bulletIdx += 1;
    return (
      <Box
        component="li"
        sx={{ display: "flex", alignItems: "baseline", gap: 1.5, mb: 0.5 }}
      >
        <Box
          sx={{
            width: 7,
            height: 7,
            minWidth: 7,
            borderRadius: "50%",
            backgroundColor: color,
            mt: "7px",
          }}
        />
        <Typography sx={{ fontSize: 14, lineHeight: 1.8, color: "hsl(150 10% 30%)" }}>
          {children}
        </Typography>
      </Box>
    );
  },
  a: ({ href, children }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "#079344", fontWeight: 600, textDecoration: "none" }}
      onMouseOver={(e) => { e.currentTarget.style.textDecoration = "underline"; }}
      onMouseOut={(e) => { e.currentTarget.style.textDecoration = "none"; }}
    >
      {children}
    </a>
  ),
  blockquote: ({ children }) => (
    <Box
      sx={{
        borderLeft: "3px solid hsl(150 38% 17%)",
        pl: 2,
        my: 1,
        color: "hsl(150 10% 40%)",
        fontStyle: "italic",
      }}
    >
      {children}
    </Box>
  ),
  hr: () => (
    <Box
      component="hr"
      sx={{
        border: "none",
        borderTop: "1px solid hsl(140 8% 88%)",
        my: 2,
      }}
    />
  ),
};

const AnnouncementContent = ({ text }) => {
  if (!text) return null;
  bulletIdx = 0;

  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
      {text}
    </ReactMarkdown>
  );
};

export default AnnouncementContent;
